<template lang="html">
  <div class="timer">
    <h1>Työtunnit</h1>
    <timer_buttons :dis_start_time="dis_start_time" :timer_tasks="timer_tasks" @End_day="End_day" @empty_list="empty_list" @add_lounas="add_timer_list"/>
    <timer_list :timer_tasks="timer_tasks" v-if="dis_start_time"  @select_task="select_task"/>
    <b-container v-if="total_work_hours && dis_start_time == false">
      <h3>Työtehtävät</h3>
      <b-list-group>
        <b-list-group-item  v-for="(index, item) in total_time_task" :key="item">
          <b-row no-gutters  class="w-100">
            <b-col class="font-weight-bold">
              {{ item }}
            </b-col>
            <b-col md="auto" class="font-weight-bold align-left">
              {{ format_ms(index)}}
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
      <h4>Työaika yhteens: {{total_work_hours}}</h4>
    </b-container>
    <app_modals @add_timer_list="add_timer_list" :todos="todos" :old_work_done="old_work_done" :task_i="task_i" @change_link="change_link" :link="link" @update_start_time="update_start_time" :selected="selected" @remove_this_task="remove_task"/>
    <b-button size="sm" v-b-modal.modal-2 variant="info">
        Tehdyt tunnit
    </b-button>
    <b-button size="sm" variant="success" class="m-1" @click="open_timetable_page" @contextmenu.prevent="$bvModal.show('modal-3')" v-b-tooltip.hover title="Vaihda linkki klikkaamalla oikealla">
        Tuntikirjaus web
    </b-button>
    <br>
    <b-button size="sm" variant="warning" @click="clear_old_tasks">
        Tyhjennä menneet tapahtumat
    </b-button>
  </div>
</template>

<script>
import timer_buttons from './timer_buttons';
import timer_list from './timer_list';
import app_modals from './timer_modals';
import moment from 'moment';

export default {
  name:"Todo_timer",
  components: {
    timer_buttons,
    timer_list,
    app_modals
  },
  props:["todos"],
  data(){
    return {
      timer_tasks:[],
      total_work_hours: "",
      task_i: 0,
      total_time_task:{},
      dis_start_time:false,
      old_work_done:[],
      link:"",
      selected:{"task":{"title":"kala"}},
    }
  },
  methods: {
    add_timer_list(task_title){
      this.dis_start_time = true;
      let index = this.todos.findIndex(item => item.title == task_title );
      if (this.timer_tasks.length > 0){
        this.timer_tasks[this.timer_tasks.length - 1].end_time = new Date;
        this.timer_tasks[this.timer_tasks.length - 1].duration = moment(new Date).diff(moment(this.timer_tasks[this.timer_tasks.length - 1].start_time));
      }
      if(index + 1){
        this.timer_tasks.push(
          {
            task: this.todos[index],
            start_time: new Date,
            end_time:"",
            duration:"",
            id:this.task_i,
          }
        )
      }
      else{
        this.timer_tasks.push(
          {
            task: {"title":task_title},
            start_time: new Date,
            end_time:"",
            duration:"",
            id:this.task_i
          }
        )
      }
      this.task_i++;
    },
    End_day(){
      this.dis_start_time = false;
      let total_time_task = {};
      this.timer_tasks[this.timer_tasks.length - 1].end_time = new Date;
      this.timer_tasks[this.timer_tasks.length - 1].duration = moment(new Date).diff(moment(this.timer_tasks[this.timer_tasks.length - 1].start_time));
      this.total_work_hours = moment.utc(moment(new Date).diff(moment(this.timer_tasks[0].start_time))).format("HH:mm");

      this.timer_tasks.map(function(key) {
        if (total_time_task[key.task.title] > 0){
          total_time_task[key.task.title] += key.duration;
        }
        else{
          total_time_task[key.task.title] = key.duration;
        }
        key.task.duration += key.duration;
       });
       this.old_work_done.push(
         {
           title:moment.utc(new Date).format("DD.MM.YY HH:mm"),
           duration: this.total_work_hours,
           tasks: total_time_task,
         }
       )
      this.total_time_task = total_time_task;
    },
    format_ms(time) {
       return moment.utc(time).format('HH:mm');
     },
    update_start_time(new_time) {
      new_time = new_time.split(":")
      this.timer_tasks[0].start_time.setHours(new_time[0],new_time[1])
     },
    empty_list(){
      this.total_time_task = {};
      this.timer_tasks = [];
      this.total_work_hours =  "";
      this.task_i = 0;
    },
    clear_old_tasks(){
      this.old_work_done = [];
      localStorage.setItem('old_work_done', JSON.stringify([]));
    },
    open_timetable_page(){
      window.open(this.link, "_blank");
    },
    change_link(link){
      this.link = link
    },
    select_task(task){
      this.selected = task;
    },
    remove_task(direction){
      let index = this.timer_tasks.findIndex(item => item.id == this.selected.id);
      this.timer_tasks[index + direction].duration += this.timer_tasks[index].duration;
      if(direction == -1){
        this.timer_tasks[index + direction].end_time = this.timer_tasks[index].end_time;
      }else{
        this.timer_tasks[index + direction].start_time = this.timer_tasks[index].start_time;
      }
      this.timer_tasks.splice(index, 1);


    }

  },
  mounted(){
    window.addEventListener('beforeunload', (event) => {
      event.preventDefault();
      localStorage.setItem('old_work_done', JSON.stringify(this.old_work_done));
      localStorage.setItem('web_link', JSON.stringify(this.link));

    });
    if (localStorage.getItem('old_work_done'))
      this.old_work_done = JSON.parse(localStorage.getItem('old_work_done'));
    if (localStorage.getItem('web_link'))
      this.link = JSON.parse(localStorage.getItem('web_link'));

  }
}
</script>

<style lang="css" scoped>
.timer{
  width: 50%;
  max-width: 500px;
}
</style>
